import { Box } from '@eatclubapp/ec-component-library';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import useStyles from './CancelMembershipStyles';

// Layout component to
const CancelMembershipPage = ({
  children,
  currentStep,
  totalSteps,
  featureImage, // Image to show on the right if provided
  footerLeft,
  footerRight,
}) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.cancelMembershipContent}>
        <Box className={classes.cancelMembershipPage}>
          <Box className={classes.contentLeft}>
            <Box className={classes.header}>
              <Box className={classes.pageSelector}>
                Step {currentStep + 1}/{totalSteps}
              </Box>
            </Box>
            {children}
          </Box>
          {featureImage && <Box className={classes.contentRight}>{featureImage}</Box>}
        </Box>
      </Box>

      {/* Footer */}
      <Box className={classes.footer}>
        <Box className={classes.footerLeft}>{footerLeft}</Box>
        <Box className={classes.footerRight}>{footerRight}</Box>
      </Box>
    </>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CancelMembershipPage);
